import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "@/api";
import { useGetAllMemberAchievements } from "@/api/members/achievements/getAll";
import { useGetMemberAchievement } from "@/api/members/achievements/get";
import { getApi } from "@api/apiPath";
import type { IMemberAchievements } from "@api/members/achievements/routeType";
import { axiosClient, queryClient } from "@api/clients.ts";

const { getPath } = getApi("members.achievements.delete");

type IExtractedRouteType = IMemberAchievements["achievementSingleDelete"];

export type IDeleteMemberAchievement = IPickDelete<IExtractedRouteType>;

const deleteMemberAchievement: MutationFunction<
  IDeleteMemberAchievement["response"],
  IDeleteMemberAchievement["variables"]
> = ({ memberId, achievementId }) => {
  return axiosClient.delete(getPath({ memberId, achievementId }));
};

export const useDeleteMemberAchievement = createMutation({
  mutationFn: deleteMemberAchievement,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberAchievements.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberAchievement.getKey({ memberId }),
    });
  },
});
